// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bgc_a","ReactCrop--disabled":"bgc_b","ReactCrop--circular-crop":"bgc_c"};